import React from 'react';
import PropTypes from 'prop-types';

const BatteryPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M25 13.75v-1.741A2.004 2.004 0 0 0 23.005 10H5.995A2.007 2.007 0 0 0 4 12.009v7.982C4 21.098 4.893 22 5.995 22h17.01A2.007 2.007 0 0 0 25 19.991V18.25h.003c1.104 0 2-1.007 2-2.25s-.896-2.25-2-2.25H25zm-19-.753c0-.551.455-.997 1-.997h15c.552 0 1 .453 1 .997v6.006c0 .551-.455.997-1 .997H7c-.552 0-1-.453-1-.997v-6.006zM19 13h2.001a1 1 0 0 1 .999.991v4.018a.993.993 0 0 1-.999.991H19v-6zm-4 6h3v-6h-3v6zm-4 0h3v-6h-3v6zm-4-5.009c0-.547.443-.991.999-.991H10v6H7.999A1 1 0 0 1 7 18.009v-4.018z"
    />
  );
};

BatteryPath.propTypes = {
  fill: PropTypes.string,
};

export default BatteryPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/battery.jsx